import { TFilterSelected } from '@monorepo/types';
import { TFilterGroupModel, TTableVirtualScrollConfig, UiFilterModifiers } from '@monorepo/ui';
import { UTILS_GUARDS } from '../ui-filter.guards';

export const VIRTUAL_SCROLL_DEFAULT_CONFIG: TTableVirtualScrollConfig = {
  itemSize: 40,
  minBufferPx: window.screen.height / 2,
  maxBufferPx: window.screen.height / 2,
};

export const CREATE_UI_FILTER_MODEL = {
  createModel: (items: TFilterSelected[], prevModel?: TFilterGroupModel<TFilterSelected>) => {
    const createNewFilterModel = UiFilterModifiers.createFilterModelList(items, (item) => {
      if (UTILS_GUARDS.isTargetDateFilter(item)) {
        return {
          type: 'TARGET_DATE_FILTER',
          key: item.key,
          displayName: item.displayName,
          values: item.values,
          isRequired: item.isRequired,
          selectedValues: [],
          ...(item.version ? { version: item.version } : {}),
        };
      }
      if (UTILS_GUARDS.isMultiSelectFilter(item)) {
        return {
          type: 'MULTI_SELECT_FILTER',
          key: item.key,
          displayName: item.displayName,
          isRequired: item.isRequired,
          items: item.values.map((val) => ({
            ...val,
            isSelected: false,
          })),
          selectedValues: [],
          ...(item.version ? { version: item.version } : {}),
          ...(item.values.length > VIRTUAL_SCROLL_DEFAULT_CONFIG.itemSize
            ? {
                virtualScroll: VIRTUAL_SCROLL_DEFAULT_CONFIG,
              }
            : {}),
        };
      }
      if (UTILS_GUARDS.isSelectFilter(item)) {
        return {
          type: 'SELECT_FILTER',
          key: item.key,
          displayName: item.displayName,
          isRequired: item.isRequired,
          items: item.values.map((val) => ({
            value: val,
            isSelected: false,
          })),
          selectedValues: [],
          ...(item.values.length > VIRTUAL_SCROLL_DEFAULT_CONFIG.itemSize
            ? {
                virtualScroll: VIRTUAL_SCROLL_DEFAULT_CONFIG,
              }
            : {}),
        };
      }
      if (UTILS_GUARDS.isOrgFilter(item)) {
        return {
          type: 'ORG_HIERARCHY_FILTER',
          key: item.key,
          displayName: item.displayName,
          isRequired: item.isRequired,
          hierarchy: item,
          isDisabled: false,
          filteredOrgTree: {
            ...item,
            values: [],
          },
          ...(item.version ? { version: item.version } : {}),
        };
      }
      if (UTILS_GUARDS.isDurationFilter(item)) {
        return {
          type: 'DURATION_FILTER',
          key: item.key,
          displayName: item.displayName,
          isRequired: item.isRequired,
          items: item.values.map((val) => ({
            value: val,
            isSelected: false,
          })),
          selectedValues: [],
          ...(item.version ? { version: item.version } : {}),
        };
      }
      if (UTILS_GUARDS.isSingleSelectFilter(item)) {
        return {
          type: 'SINGLE_SELECT_FILTER',
          key: item.key,
          inputLabel: item.displayName,
          isRequired: item.isRequired,
          items: item.values.map((val) => ({
            value: val.value,
            displayName: val.displayName,
          })),
        };
      }
      throw new Error('Type Not suppported');
    });
    const updatedFilterModel = prevModel
      ? UiFilterModifiers.updateFilterModelList(createNewFilterModel, prevModel)
      : createNewFilterModel;
    return UiFilterModifiers.sortFilterItems(updatedFilterModel);
  },

  filterUpdateByGroup(
    filterGroupModel: TFilterGroupModel<TFilterSelected>,
    groupModeInfo: TFilterGroupModel<TFilterSelected>['groups'][number],
  ) {
    return UiFilterModifiers.filterUpdateByGroup(filterGroupModel, groupModeInfo);
  },
};
